import "jquery/dist/jquery.min.js";
import Endpoints from "@/config/ApiEndpoints.js";
import Axios from "axios";
import { googleMapApiKey } from '@/constants/config';
import DirectionsRenderer from "@/pages/vehicles/vehicletrips/DirectionsRenderer";
var moment = require("moment");

  export default {
  	props: ["VehicleId","RegistrationRegion"],
    components: {          
      DirectionsRenderer,
    },
    filters: {
      date: function (data) {
        var sendDate = "N/A";
        if (data != "" && data != null) {
          sendDate = moment(data).format("DD-MM-YYYY");
        }
        return sendDate;
      },
      datetime: function (data) {
        var sendDate = "N/A";
        if (data != "" && data != null) {
          sendDate = moment(data).format("DD-MM-YYYY hh:mm A");
        }
        return sendDate;
      },      
    },
    data() {
      return {        
        VehicleTrips:[],
        VehicleTripsMsg:"",
        VehicleTripsfromDate: moment(new Date()).subtract(9, 'd').format("YYYY-MM-DD"),
      	VehicleTripstoDate: moment(new Date()).format("YYYY-MM-DD"),      	
      	tripPaging: {
        	currentPage: 1,
        	totalPages: 0,
      	},        
      	
      	ShowTripOnMapModel:false,
      	start: "",
    	end: "",

      };
    },   
    mounted() {      
      this.VehicleId = this.$route.params.VehicleId;       
      this.ShowVehicleTrips();
    },
    computed: {
    	origin() {
      		if (!this.start) return null;
      		return { query: this.start };
    	},
    	destionation() {
      		if (!this.end) return null;
      		return { query: this.end };
    	},    		
  	},
    methods: {             
      ShowVehicleTrips(type = ""){ 
      	this.VehicleTrips=[];     	    	
      	this.VehicleTripsMsg="";  
      	this.ShowVehicleTripsModel = true;        	 	    	      	
	    var obj = { token: localStorage.getItem("token"),vehicle_id: this.VehicleId };
	    if (type == "search") {
	    	obj.fromDate = this.VehicleTripsfromDate;
        	obj.toDate = this.VehicleTripstoDate;

        	this.$swal.fire({
				title: "Fetching Vehicle Trips...",	          
				text: "Please wait...",	          
				showConfirmButton: false,
				allowOutsideClick: false,
	    	});
	    }
        Axios.post(Endpoints.Vehicle.GetInseegoVehicleTrips,obj).then((Response) => {                    	 
          	this.VehicleTrips = Response?.data?.VehicleTrips || [];          	          
          	this.VehicleTripsMsg = Response?.data?.message || "Something went wrong";
          	this.$swal.close();
          	if (Response?.data?.success) {          	          	          
          	}
        });
      },
      changeDate(type){
      	var fromDate = new Date(this.VehicleTripsfromDate);
      	var toDate = new Date(this.VehicleTripstoDate);      	
      	var diff = (toDate.getTime() - fromDate.getTime()) / (1000*60*60*24);      	
      	if(isNaN(diff) || diff > 9){
      		if(type=='VehicleTripsfromDate'){
      			toDate = new Date(this.VehicleTripsfromDate);;
      			toDate.setDate(toDate.getDate() + 9);
      			this.VehicleTripstoDate = toDate.getFullYear()+'-'+((toDate.getMonth() + 1).toString().padStart(2, "0"))+'-'+(toDate.getDate().toString().padStart(2, "0"));      			
      		}else{
      			fromDate = new Date(this.VehicleTripstoDate);;      			
      			fromDate.setDate(fromDate.getDate() - 9);      			
      			this.VehicleTripsfromDate = fromDate.getFullYear()+'-'+((fromDate.getMonth() + 1).toString().padStart(2, "0"))+'-'+(fromDate.getDate().toString().padStart(2, "0"));      			
      		}
      	} 
      	     	
      },
      ShowTripOnMap(VehicleTrip){      		
		if(VehicleTrip?.StartLatitude && VehicleTrip?.StartLongitude){
			this.center = {lat: VehicleTrip.StartLatitude, lng: VehicleTrip.StartLongitude};
		}		
		this.start = VehicleTrip?.StartLocation || '';		        		
		this.end = VehicleTrip?.EndLocation || '';		
		
		this.ShowTripOnMapModel = true;				        				        		
      },      

    },
  };
